<div class="{{store.state.common.helpToggleEnabled && !forceBigView ? 'col-md-8' : 'col-md-12'}}"
     [ngClass]="paddingLeft ? '' : 'section-col-pad'">
    <ng-content></ng-content>
</div>